import { createContext, useContext, useEffect, useState } from "react";
import { admin, saveToken, clearToken, getToken } from "./api";

const AuthCtx = createContext(null);

export function AdminAuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=none, object=admin
  useEffect(() => {
    async function check() {
      if (!getToken()) {
        setUser(false);
        return;
      }
      try {
        const { data } = await admin.get("/auth/me");
        setUser(data);
      } catch {
        clearToken();
        setUser(false);
      }
    }
    check();
  }, []);

  async function login(email, password) {
    const { data } = await admin.post("/auth/login", { email, password });
    saveToken(data.access_token);
    setUser(data.user);
    return data.user;
  }

  async function logout() {
    try {
      await admin.post("/auth/logout");
    } catch (e) {
      /* ignore */
    }
    clearToken();
    setUser(false);
  }

  return (
    <AuthCtx.Provider value={{ user, login, logout }}>{children}</AuthCtx.Provider>
  );
}

export function useAdminAuth() {
  return useContext(AuthCtx);
}
